import * as React from 'react';

export default function Actions({links}) {
  if (!links || !Array.isArray(links) || !links.length) return null;

  return (
    <div className='accordion-item__actions'>
      {links.map((link, idx) => {
        const {url} = link;
        let safeHref;
        try {
          const parsed = new URL(url, window.location.origin);
          if (!['http:', 'https:', 'mailto:'].includes(parsed.protocol)) return null;
          safeHref = parsed.toString();
        } catch {
          return null;
        }

        return <a key={idx} href={safeHref} className='nv-cta-secondary nv-cta-secondary--small' rel='noopener noreferrer'>
          {link.text}
        </a>;
      })}
    </div>
  );
}
